import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {FaqNodeDetailDto, FaqFolderDetailDto} from '../../domain/faq/faqNodeDetailDto';
import {FaqNodeDto, FaqSearchParams} from '../../domain/faq/faqNodeDto';
import {HttpParamsUtil} from './utils/httpParams.util';

@Injectable({
    providedIn: 'root'
})
export class FaqHttpService {
    private readonly resourceLocation: string = '/v2/front/faq/nodes';

    constructor(private readonly http: HttpClient) {
    }

    public findRootNode(): Observable<FaqFolderDetailDto> {
        return this.http.get<FaqFolderDetailDto>(`${this.resourceLocation}/root`);
    }

    public findNode(faqNodeId: string): Observable<FaqNodeDetailDto> {
        return this.http.get<FaqNodeDetailDto>(`${this.resourceLocation}/${faqNodeId}`);
    }

    public search(params: FaqSearchParams): Observable<FaqNodeDto[]> {
        return this.http.get<FaqNodeDto[]>(`${this.resourceLocation}`,
            {params: HttpParamsUtil.toHttpParams(params)});
    }
}
